export class DomIdProvider {
    constructor(blockUniqueId) {
        this.blockUniqueId = blockUniqueId;
    }
    getElementId(tag) {
        return `dom_${this.blockUniqueId}_${tag}`;
    }
}
//# sourceMappingURL=DomIdProvider.js.map